import { useUpdateMedicineSummary } from 'src/hooks/summary';
import { createMedicinePayload } from 'src/utils/summary/helpers';
import PrescriptionFormModal from './PrescriptionFormModal';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';

const EditOrderModal = ({
  open,
  onClose,
  order,
  encounterId,
  onOrderUpdated,
}) => {
  const updateMedicineMutation = useUpdateMedicineSummary();

  const handleUpdateOrder = async (values) => {
    if (!order) return;

    const medicineData = createMedicinePayload(values, order.prescription);

    try {
      await updateMedicineMutation.mutateAsync({
        encounterId,
        medicines: [medicineData],
      });

      onOrderUpdated(order.id, values);
      showToastSuccess(`Order for ${values.name} updated.`);
      onClose();
    } catch (error) {
      console.error('Error updating order:', error);
      showToastError(`Failed to update order for ${values.name}.`);
    }
  };

  const initialValues = order
    ? {
        ...order.prescription,
        warnings: Array.isArray(order.prescription.warnings)
          ? order.prescription.warnings.join(', ')
          : order.prescription.warnings || '',
      }
    : null;

  return (
    <PrescriptionFormModal
      open={open}
      onClose={onClose}
      onSubmit={handleUpdateOrder}
      initialValues={initialValues}
      encounterId={encounterId}
    />
  );
};

export default EditOrderModal;
